import { Expose } from 'class-transformer';

export class UserPermissionsDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'booking' })
  booking: boolean;
  @Expose({ name: 'inviting_guests' })
  invitingGuests: boolean;
  @Expose({ name: 'guest_vehicle' })
  guestVehicle: boolean;
  @Expose({ name: 'repeatable_guests' })
  repeatableGuests: boolean;
  @Expose({ name: 'service_call' })
  serviceCall: boolean;
  @Expose({ name: 'personal_credits' })
  personalCredits: boolean;
  @Expose({ name: 'show_all_guests' })
  showAllGuests: boolean;
}
